module.exports = "/assets/data/dfdf802bd501c42fd0ab174ab65c5c12-CV8.data.json";